import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { HiMiniArrowLeft } from "react-icons/hi2";

const CategoryDetail = () => {
  const { slug } = useParams();
  const [categoryData, setCategoryData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCategoryData = async () => {
      try {
        setLoading(true);
        const categoriesResponse = await fetch('https://api.gmskripto.com/public/api/categories');
        const categoriesData = await categoriesResponse.json();
        
        const category = categoriesData.data.find(cat => cat.slug === slug);
        
        if (!category) {
          throw new Error('Kategori bulunamadı');
        }

        const response = await fetch(`https://api.gmskripto.com/public/api/categories/${category.id}`);
        
        if (!response.ok) {
          throw new Error('Kategori verileri yüklenirken bir hata oluştu');
        }
        
        const data = await response.json();
        setCategoryData(data.data);
      } catch (err) {
        setError(err.message);
        console.error('Error fetching category data:', err);
      } finally {
        setLoading(false);
      }
    };

    if (slug) {
      fetchCategoryData();
    }
  }, [slug]);

  if (loading) {
    return (
        <div className="min-h-screen bg-[rgb(24,25,29)] flex items-center justify-center">
        <div className="text-center">
          <div className="relative">
            <div className="w-16 h-16 border-4 border-purple-500/30 border-t-purple-500 rounded-full animate-spin mx-auto mb-4"></div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-[rgb(24,25,29)] flex items-center justify-center">
        <div className="text-red-400 text-xl text-center">
          <div>Hata: {error}</div>
          <Link 
            to="/destek-merkezi"
            className="mt-4 inline-block px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700"
          >
            Destek Merkezine Dön
          </Link>
        </div>
      </div>
    );
  }

  if (!categoryData) {
    return (
      <div className="min-h-screen bg-[rgb(24,25,29)] flex items-center justify-center">
        <div className="text-gray-400 text-xl">Kategori bulunamadı</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[rgb(24,25,29)]">
      <div className="container mx-auto px-6 py-12">
        <div className="mb-8">
          <Link 
            to="/destek-merkezi"
            className="inline-flex items-center text-purple-400 hover:text-purple-300 mb-4"
          >
            <HiMiniArrowLeft className="w-5 h-5 mr-2" />
            Destek Merkezine Dön
          </Link>
        </div>

        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-white mb-4">{categoryData.name}</h1>
          {categoryData.description && (
            <p className="text-gray-400 text-lg max-w-2xl mx-auto">
              {categoryData.description}
            </p>
          )}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {categoryData.faqs && categoryData.faqs.length > 0 ? (
            categoryData.faqs.map((faq, index) => (
              <div 
                key={faq.id} 
                className="border border-purple-800/30 rounded-xl p-6 transition-all duration-300 hover:border-purple-600 bg-gradient-to-br from-purple-900/10 to-black/30"
              >
                <div className="flex items-start space-x-4">
                  <div className="text-purple-400 flex-shrink-0">
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-semibold text-white mb-2 line-clamp-2">
                      {faq.question}
                    </h3>
                    <p className="text-gray-400 text-sm line-clamp-3">
                      {faq.answer_excerpt}
                    </p>
                    <div className="mt-4 flex items-center justify-between">
                      <span className="text-xs text-gray-500">
                        {new Date(faq.created_at).toLocaleDateString('tr-TR')}
                      </span>
                      <Link
                        to={`/destek-merkezi/${slug}/${faq.slug}`}
                        className="inline-flex items-center text-purple-400 hover:text-purple-300 text-sm"
                      >
                        Devamını Oku
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                        </svg>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="col-span-full text-center text-gray-400 text-xl py-12">
              Bu kategoride henüz soru bulunmuyor.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CategoryDetail; 